module.exports = __webpack_public_path__ + "img/loc-icon.3bba5389.svg";